export default __webpack_public_path__ + "static/media/Almost_color.35a59bb2.svg";